<template>
  <div class="shell">
    <el-row align="middle">
      <el-col :md="12" :sm="24" class="left">
        <div>
          <img src="@/assets/img/logos/logo-v.png" class="logo">
          <h1>{{ $t(`${translationPrefix}.catchPhrase`) }}</h1>
          <p>{{ $t(`${translationPrefix}.supplementaryText`) }}</p>
          <router-link v-show="false" :to="{ name: 'registration' }"><el-button type="info">{{ $t(`${translationPrefix}.buttons.notRegistered`) }}</el-button></router-link>
          <p>{{ $t(`${translationPrefix}.betaText`) }}</p>
        </div>
      </el-col>
      <el-col :md="12" :sm="24" class="right":style="{ backgroundImage: 'url(' +require(`@/assets/img/desktop-hero.jpg`)+ ')' }" >
        <login class="login"></login>
        <register class="register"></register>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import Login from '@/components/user/Login';
  import Register from '@/components/user/Register';

  export default {
    name: 'HomePage',
    components: {
      login: Login,
      register: Register,
    },
    computed: {
    },
    data() {
      return {
        translationPrefix: 'pages.home',
      };
    },
  };
</script>

<style lang="scss">
  $content-height-init: 100vh;
  $padding-vert: 40px;
  $padding-total: $padding-vert*2;
  $content-height: calc(#{$content-height-init} - #{$padding-total});

  $--sm: 768px !default;
  $--md: 992px !default;
  $--lg: 1200px !default;
  $--xl: 1920px !default;

  .shell{
    @media only screen and (min-width:$--lg){
      margin: $padding-vert 0px;
    }
    >.el-row {
      max-width: 1440px;
      margin: auto;
      background-color: #fff;
      box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.1);
      .left{
        height: $content-height;
        padding: 0px 100px;
        display: flex;
        align-items: center;
        @media only screen and (max-width:$--md){
          padding: 20px 20px;
          height: auto;
          min-height: $content-height;
          height: $content-height-init;
        }
        .logo{
          display: block;
          max-width: 211px;
          margin: auto;
          padding: 10% 0px;
        }
        p{
          font-size: 20px;
          color: #6A636B;
          letter-spacing: 0.09px;
          line-height: 28px;
          @media only screen and (max-width:$--lg){
            font-size: 16px;
          }
        }
      }
      .right{
        border: solid 10px white;
        height: $content-height;
        padding: 0px 100px;
        background:{
          repeat: no-repeat;
          size: cover;
          position: center;
        }
        display: flex;
        align-items: center;
        @media only screen and (max-width:$--md){
          padding: 20px 20px;
          height: $content-height-init;
        }
        .login{
          flex:1;
        }
        .register{
          display: none;
        }
      }
    }    
  }

</style>


// WEBPACK FOOTER //
// src/pages/Home.vue